import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import SEO from '../components/seo';

import ContactForm from '../components/ContactForm';
import { Container, H1, P } from '../components/styled/PackageContactForms';
import SlantedContainer from '../components/SlantedContainer';

const BuildAnAppPage = () => {

  const data = useStaticQuery(graphql`{
    allFile(filter: {
      name: { eq: "build-an-app" }
      sourceInstanceName: { eq: "pages" }
    }) {
      edges {
        node {
          childPagesJson {
            title
            description
            contactFormTitle
            seo {
              title
              description
              keywords
            }
          }
        }
      }
    }
  }`);

  const {
    title,
    description,
    contactFormTitle,
    seo,
  } = data.allFile.edges[0].node.childPagesJson;

  return (
    <div>

      <SEO {...seo} />

      <Container>
        <H1>{title}</H1>
        <P dangerouslySetInnerHTML={{ __html: description }} />
      </Container>

      <SlantedContainer color="background3" hideBottomSlant={true}>
        <ContactForm 
          title={contactFormTitle}
          selectedProjectType={0} />
      </SlantedContainer>
    </div>
  );
};

export default BuildAnAppPage;
